import Pedido from "model/producao/Pedido";
import { api } from "api/api";
import { AxiosError } from "axios";
import { EmitirNotaFiscalSaida, OpcoesEmissaoNotaFiscalSaida, ParametrosFiscaisItemNotaFiscalSaida, ResultadoConsultaNotaFiscalSaida, ResultadoEmissaoNotaFiscalSaida } from "model/vendas/EmitirNotaFiscalSaida";
import Pessoa from "model/administracao/cadastro/Pessoa";
import EstoqueLote from "model/suprimentos/EstoqueLote";
import NotaFiscalSaida from "model/vendas/NotaFiscalSaida";
import NotaFiscalSaidaDocumento from "model/vendas/NotaFiscalSaidaDocumento";
import NotaFiscalSaidaEmail from "model/vendas/NotaFiscalSaidaEmail";
import { EmitirCartaCorrecaoNotaFiscalSaida, ResultadoCartaCorrecaoNotaFiscalSaida } from "model/vendas/CartaCorrecaoNotaFiscalSaida";
import { CancelarNotaFiscalSaida, ResultadoCancelamentoNotaFiscalSaida } from "model/vendas/CancelarNotaFiscalSaida";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { getFilters } from "utils/filterUtils";

export default class NotaFiscalSaidaService {
    listarEmails(id: number): Promise<NotaFiscalSaidaEmail[]> {
        return api.get<NotaFiscalSaidaEmail[]>(`/notaFiscalSaida/${id}/emails`).then(response => response.data);
    }

    enviarEmail(id: number, destinatario: string): Promise<NotaFiscalSaidaEmail> {
        return api.post<NotaFiscalSaidaEmail>(`/notaFiscalSaida/${id}/emails`, { destinatario })
            .then(response => response.data);
    }

    listarDocumentos(id: number): Promise<NotaFiscalSaidaDocumento[]> {
        return api.get<NotaFiscalSaidaDocumento[]>(`/notaFiscalSaida/${id}/documentos`)
            .then(response => response.data);
    }

    baixarDocumentoHistorico(idNota: number, idDocumento: number): Promise<Blob> {
        return api.get<Blob>(`/notaFiscalSaida/${idNota}/documentos/${idDocumento}/xml`, { responseType: "blob" })
            .then(response => response.data);
    }

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null): Promise<Page> {
        return api.get<Page>(`/notaFiscalSaida/pesquisar${getFilters(filters)}`, {
            params: { page: page.page, size: page.size, sort: page.sort }
        }).then(response => response.data);
    }

    consultar(id: number): Promise<NotaFiscalSaida> {
        return api.get<NotaFiscalSaida>(`/notaFiscalSaida/consultar/${id}`).then(response => response.data);
    }

    emitirCartaCorrecao(id: number, dados: EmitirCartaCorrecaoNotaFiscalSaida): Promise<ResultadoCartaCorrecaoNotaFiscalSaida> {
        return api.post<ResultadoCartaCorrecaoNotaFiscalSaida>(`/notaFiscalSaida/${id}/cartaCorrecao`, dados)
            .then(response => response.data);
    }

    listarCartasCorrecao(id: number): Promise<ResultadoCartaCorrecaoNotaFiscalSaida[]> {
        return api.get<ResultadoCartaCorrecaoNotaFiscalSaida[]>(`/notaFiscalSaida/${id}/cartasCorrecao`)
            .then(response => response.data);
    }

    buscarEdicao(id: number): Promise<EmitirNotaFiscalSaida> {
        return api.get<EmitirNotaFiscalSaida>(`/notaFiscalSaida/${id}/edicao`).then(response => response.data);
    }

    prepararDuplicacao(id: number): Promise<EmitirNotaFiscalSaida> {
        return api.get<EmitirNotaFiscalSaida>(`/notaFiscalSaida/${id}/duplicacao`).then(response => response.data);
    }

    consultarParametrosFiscais(dados: EmitirNotaFiscalSaida): Promise<ParametrosFiscaisItemNotaFiscalSaida[]> {
        return api.post<ParametrosFiscaisItemNotaFiscalSaida[]>("/notaFiscalSaida/parametrosFiscais", dados)
            .then(response => response.data);
    }

    excluir(id: number): Promise<void> {
        return api.delete<void>(`/notaFiscalSaida/${id}`).then(() => undefined);
    }

    cancelar(id: number, dados: CancelarNotaFiscalSaida): Promise<ResultadoCancelamentoNotaFiscalSaida> {
        return api.post<ResultadoCancelamentoNotaFiscalSaida>(`/notaFiscalSaida/${id}/cancelar`, dados)
            .then(response => response.data);
    }

    atualizarDadosXml(id: number): Promise<void> {
        return api.post<void>(`/notaFiscalSaida/${id}/atualizarDadosXml`)
            .then(() => undefined);
    }

    baixarXml(id: number): Promise<Blob> {
        return api.get<Blob>(`/notaFiscalSaida/${id}/xml`, { responseType: "blob" })
            .then(response => response.data);
    }

    baixarCarta(id:number,evento:number):Promise<Blob>{return api.get<Blob>(`/notaFiscalSaida/${id}/cartasCorrecao/${evento}/pdf`,{responseType:"blob"}).then(r=>r.data);}
    exportarXml(ids:number[]):Promise<Blob>{return api.post<Blob>("/notaFiscalSaida/exportarXml",ids,{responseType:"blob"}).then(r=>r.data);}
    baixarDanfe(id: number): Promise<Blob> {
        return api.get<Blob>(`/notaFiscalSaida/${id}/danfe`, { responseType: "blob" })
            .then(response => response.data);
    }

    prepararPedido(id: number): Promise<Pedido> {
        return api.get<Pedido>(`/notaFiscalSaida/pedido/${id}/preparar`).then(response => response.data);
    }

    opcoesEmissao(): Promise<OpcoesEmissaoNotaFiscalSaida> {
        return api.get<OpcoesEmissaoNotaFiscalSaida>("/notaFiscalSaida/opcoesEmissao")
            .then(response => response.data);
    }

    consultarCliente(id: number): Promise<Pessoa> {
        return api.get<Pessoa>(`/notaFiscalSaida/cliente/${id}`).then(response => response.data);
    }

    getLotesDisponiveis(codigoDeposito: string, codigoProduto: string): Promise<EstoqueLote[]> {
        return api.get<EstoqueLote[]>(`/notaFiscalSaida/lotesDisponiveis/${encodeURIComponent(codigoDeposito)}/${encodeURIComponent(codigoProduto)}`)
            .then(response => response.data);
    }

    consultarSituacao(id: number): Promise<ResultadoConsultaNotaFiscalSaida> {
        return api.post<ResultadoConsultaNotaFiscalSaida>(`/notaFiscalSaida/${id}/consultarSituacao`)
            .then(response => response.data);
    }

    emitir(nota: EmitirNotaFiscalSaida): Promise<ResultadoEmissaoNotaFiscalSaida> {
        return this.enviar("/notaFiscalSaida/emitir", nota);
    }

    reenviar(id: number, nota: EmitirNotaFiscalSaida): Promise<ResultadoEmissaoNotaFiscalSaida> {
        return this.enviar(`/notaFiscalSaida/${id}/reenviar`, nota);
    }

    private enviar(url: string, nota: EmitirNotaFiscalSaida): Promise<ResultadoEmissaoNotaFiscalSaida> {
        const requisicao = {
            ...nota,
            unidadeOrganizacional: nota.unidadeOrganizacional && { id: nota.unidadeOrganizacional.id },
            serieNotaFiscal: nota.serieNotaFiscal && { id: nota.serieNotaFiscal.id },
            transacaoNotaFiscal: nota.transacaoNotaFiscal && { id: nota.transacaoNotaFiscal.id },
            destinatario: nota.destinatario && { id: nota.destinatario.id },
            enderecoDestinatario: nota.enderecoDestinatario && { id: nota.enderecoDestinatario.id },
            representante: nota.representante && { id: nota.representante.id },
            condicaoPagamento: nota.condicaoPagamento && { id: nota.condicaoPagamento.id },
            itens: nota.itens.map(item => ({ ...item,
                produto: item.produto && { codigo: item.produto.codigo },
                deposito: item.deposito && { codigo: item.deposito.codigo }
            })),
            pagamentos: nota.pagamentos.map(pagamento => ({ ...pagamento,
                formaPagamento: pagamento.formaPagamento && { id: pagamento.formaPagamento.id }
            }))
        };
        return api.post<ResultadoEmissaoNotaFiscalSaida>(url, requisicao)
            .then(response => response.data)
            .catch((error: AxiosError<ResultadoEmissaoNotaFiscalSaida>) => {
                // Uma falha de preparação preserva o registro local e seu ID.
                if (error.response?.status === 422 && error.response.data?.idNotaFiscalSaida) {
                    return error.response.data;
                }
                throw error;
            });
    }
}
